import { Atto } from '../../../models/atto';


export class AttoAdapter {

  atto: Atto = new Atto();

  constructor(atto: Atto) {
    this.atto.id = atto.id;
    this.atto.provenienza = atto.provenienza ? JSON.parse(JSON.stringify(atto.provenienza)) : null;
    this.atto.tipoAtto = atto.tipoAtto ? JSON.parse(JSON.stringify(atto.tipoAtto)) : null;
    this.atto.numeroProtocollo = atto.numeroProtocollo;
    this.atto.dataProtocollo = atto.dataProtocollo;
    this.atto.dataDeposito = atto.dataDeposito;
    this.atto.dataNotifica = atto.dataNotifica;
    this.atto.dataApposizioneFormulaEsecutiva = atto.dataApposizioneFormulaEsecutiva;
    this.atto.titoloEsecutivo = atto.titoloEsecutivo ? atto.titoloEsecutivo : false ;
    this.atto.note = atto.note;
    this.atto.dataPubblicazione = atto.dataPubblicazione;
    this.atto.documenti = atto.documenti;
  }
}

